import { Flame, Star, Leaf, Ban, Wine, Sprout, WheatOff } from "lucide-react";

// Canonical dietary tag ids used by the backend.
export const DIETARY_TAGS = [
  { id: "veg",                label: "Veg",               short: "Veg",         icon: "square-veg",      color: "#16A34A" },
  { id: "vegan",              label: "Vegan",             short: "Vegan",       icon: "sprout",          color: "#0E7A3B" },
  { id: "non_veg",            label: "Non-Veg",           short: "Non-Veg",     icon: "square-nonveg",   color: "#DC2626" },
  { id: "pure_jain",          label: "Pure Jain",         short: "Jain",        icon: "square-jain",     color: "#CA8A04" },
  { id: "no_onion_garlic",    label: "No Onion / Garlic", short: "No O&G",      icon: "leaf",            color: "#15803D" },
  { id: "gluten_free",        label: "Gluten-Free",       short: "Gluten-Free", icon: "wheat-off",       color: "#92400E" },
  { id: "spicy",              label: "Spicy",             short: "Spicy",       icon: "flame",           color: "#EA580C" },
  { id: "chefs_special",      label: "Chef's Special",    short: "Chef's",      icon: "star",            color: "#7C3AED" },
  { id: "bartenders_special", label: "Bartender's Special", short: "Bartender's Special", icon: "wine",          color: "#BE123C" },
];

export const TAG_BY_ID = Object.fromEntries(DIETARY_TAGS.map((t) => [t.id, t]));

// A compact pictogram for each tag. `size` controls the outer square in pixels.
export function TagIcon({ id, size = 14, title }) {
  const meta = TAG_BY_ID[id];
  if (!meta) return null;
  const px = `${size}px`;
  const t = title ?? meta.label;

  if (meta.icon === "flame")
    return <Flame style={{ width: px, height: px, color: meta.color }} aria-label={t} />;
  if (meta.icon === "star")
    return <Star style={{ width: px, height: px, color: meta.color }} fill={meta.color} aria-label={t} />;
  if (meta.icon === "wine")
    return <Wine style={{ width: px, height: px, color: meta.color }} aria-label={t} />;
  if (meta.icon === "leaf")
    return (
      <span style={{ position: "relative", display: "inline-flex" }} aria-label={t}>
        <Leaf style={{ width: px, height: px, color: meta.color }} />
        <Ban style={{ width: `${size * 0.9}px`, height: `${size * 0.9}px`, color: "#9CA3AF", position: "absolute", top: "-1px", left: "1px", opacity: 0.6 }} />
      </span>
    );

  // Classic Indian food mark: bordered square with centered dot.
  const inner = Math.max(3, Math.round(size * 0.32));
  const jainJ = meta.icon === "square-jain";
  return (
    <span
      style={{
        width: px, height: px, border: `1.5px solid ${meta.color}`,
        display: "inline-flex", alignItems: "center", justifyContent: "center",
        borderRadius: "2px", background: "#fff", color: meta.color,
      }}
      aria-label={t}
      title={t}
    >
      {jainJ ? (
        <span style={{ fontSize: `${size * 0.62}px`, fontWeight: 800, lineHeight: 1 }}>J</span>
      ) : (
        <span style={{ width: `${inner}px`, height: `${inner}px`, borderRadius: "999px", background: meta.color, display: "block" }} />
      )}
    </span>
  );
}

// Normalize legacy single-string value to the new list shape.
export function normalizeDietary(value) {
  if (Array.isArray(value)) return value;
  if (typeof value === "string") return value === "none" || !value ? [] : [value];
  return [];
}
